import React from 'react';
// import { Input, Button } from 'elements';
import strings from '../../../../utils/translationStrings';

import './DescriptionSection.scss';

export const DescriptionSection = () => {
  return (
    <section id="description" className="description">
      <div className="description__container">
        <h1 className="description__slogan">{strings.landing.description.slogan}</h1>
        <div className="description__image" />
        <div className="description__text">{strings.landing.description.text}</div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Landing/Partial/DescriptionSection/DescriptionSection.js